import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { createQueryClient } from '@/api/queryClient'
import App from '@/App'
import { AuthProvider } from '@/auth/AuthProvider'
import { ToastProvider } from '@/components/ui'

import './index.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('index.html is missing <div id="root">.')
}

const queryClient = createQueryClient()

/**
 * Provider order matters: `AuthProvider` runs queries, so it must sit inside
 * `QueryClientProvider`; `ToastProvider` sits above it so a sign-out failure
 * has somewhere to report itself.
 */
createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
